/* eslint-disable no-nested-ternary */
import React, { useState, useContext, useRef, useEffect } from 'react'
import moment from 'moment'
import {
  message as mes,
  util, request, auth as userAuth } from 'meinian-package/src/utils'
import { formatNumber100Add } from 'meinian-package/src/utils/number'
import { teamHasAuth } from 'meinian-package/src/utils/auth'
import Icon from 'meinian-package/src/component/icon'
import versionNumber from 'meinian-package/src/component/useFunModal/versionNumber'
import useVersionNumber from 'meinian-package/src/common/hooks/useVersionNumber'
import classNames from 'classnames'
import { Ul, Li, Dropdown } from 'meinian-package/src/baseComponent'
import { MARK_STATUS, IDEA_MASS_ROLE } from 'meinian-package/src/component/enum'
import { PLATFORM_VALUE, PLATFORM_CONFIG_ENUM } from 'meinian-package/src/component/platformConfig'
import { renderMoveImage } from 'meinian-package/src/component/useFunModal/moveImage'
import renderRepeatCollectModalApiWrap from '../../useFunModal/repeatCollectModal'
import Upgrade from '../../imageDetail/upgradeImage'
import PrintImage from '../../printImage'
import { QuickEdit } from '../../imageDetail/info'
import DownloadCenter from '../../download'
import { AccountContext } from '../../../context'
import CollectGroupBtn from '../../collectGroupBtn'
import CardExamine from './cardExamine'
import RejectComment from '../../examine/rejectComment'
import { Remove, DownloadImage, MoreBtn } from '../action'
import './image.base.less'
import './index.less'

const getSourceDtoData = (platformId, item) => {
  const _dto = PLATFORM_CONFIG_ENUM.has(platformId) ? item[PLATFORM_CONFIG_ENUM.get(platformId).dto] : {}

  const sourceData = {
    [PLATFORM_VALUE.ITEM]: { originalUrl: `https://item.taobao.com/item.htm?id=${_dto?.itemId}` },
    [PLATFORM_VALUE.WEIBO]: { originalUrl: _dto?.bloggerUrl, },
    [PLATFORM_VALUE.INS]: { originalUrl: _dto?.blogUrl },
    [PLATFORM_VALUE.XIAOHONGSHU]: { originalUrl: `https://www.xiaohongshu.com/discovery/item/${item?.childEntityId}`, },
    [PLATFORM_VALUE.BRAND]: { originalUrl: '', },
    [PLATFORM_VALUE.DW]: { originalUrl: '', },
    [PLATFORM_VALUE.DW_GOODS]: { originalUrl: '' },
    [PLATFORM_VALUE.SHOW]: { originalUrl: '', },
    [PLATFORM_VALUE.JP]: { originalUrl: '', },
    [PLATFORM_VALUE.WHOLESALE]: { originalUrl: '', },
    [PLATFORM_VALUE.RETAIL]: { originalUrl: '', },
    [PLATFORM_VALUE.UPLOAD]: { originalUrl: '', },
    [PLATFORM_VALUE.CROSSBORDER]: { originalUrl: '', },
    [PLATFORM_VALUE.DHH]: { originalUrl: '', },
    [PLATFORM_VALUE.INSGOODS]: { originalUrl: _dto?.productUrl },
    [PLATFORM_VALUE.PORTER]: { originalUrl: '', },
    [PLATFORM_VALUE.FARFETCH]: { originalUrl: '', },
    [PLATFORM_VALUE.SSENSE]: { originalUrl: '', },
    [PLATFORM_VALUE.CROSSBORDER_INS]: { originalUrl: _dto?.blogUrl, },
    [PLATFORM_VALUE.CROSSBORDER_INS_GOODS]: { originalUrl: _dto?.productUrl, },
    [PLATFORM_VALUE.CROSSBORDER_SHOW]: { originalUrl: '', },
    [PLATFORM_VALUE.XIU_CHANGE_XI_JIE]: { originalUrl: '', },
    [PLATFORM_VALUE.SHI_ZHUANG_DA_PIAN]: { originalUrl: '', },
    [PLATFORM_VALUE.DY]: { originalUrl: `https://haohuo.jinritemai.com/ecommerce/trade/detail/index.html?h5_origin_type=detail_share&id=${item?.imageGroupEntityId}`, },
    [PLATFORM_VALUE.DY_WORKS]: { originalUrl: _dto?.videoUrl, }
  }
  return sourceData[platformId] ? sourceData[platformId] : {}
}

export const Layer = (props) => {
  const {
    itemData,
    materialFlag,
    hasMarkPermissions,
    onItemDataChange,
    outerIndex,
    data,
    showMoveImage,
    childrenFlag,
    allStyleFlag,
    hiddenMark = true,
    onDeleteItem,
    onChange,
  } = props

  const {
    inspirationId,
    duplicateBlogNum,
    blogComment,
    imageGroupEntityId,
    unionId,
    platformId,
    loginUserInfo,
    collectId,
    mainUrl,
    inspirationName
  } = itemData

  const auth = loginUserInfo?.inspirationPermissions || []
  const account = useContext(AccountContext)
  const { userInfo = {} } = account
  const [dropDownVisible, setDropDownVisible] = useState(false)

  const rejectCommentRef = useRef(null)
  const [upgradeInfo, setUpgradeInfo] = useState({})

  useEffect(() => {
    if (dropDownVisible) {
      if (!unionId || !imageGroupEntityId || !inspirationId || !platformId) { return }
      if (!userAuth.isPermissions(auth, ['FS05', 'FS05_CREATOR', 'FCS06', 'FCS06_CREATOR', 'FS14', 'FCS15'])) {
        return
      }
      fetchUpgradeInfo?.()
    }
  }, [dropDownVisible])

  const fetchUpgradeInfo = async () => {
    if (!inspirationId || !imageGroupEntityId) return
    const res = await request.sget('/zhikuan/image-bus/get-style-detail', { inspirationId, entityId: imageGroupEntityId }, 'MN_fetchImageUpgradeInfo')
    delete res?.platformId
    const itemInfoDTOList = res?.itemInfoDTOList
    const goodList = []
    if (itemInfoDTOList?.length > 0) {
      for (let i = 0; i < itemInfoDTOList.length; i++) {
        goodList.push({
          itemId: res?.itemIdList[i],
          title: itemInfoDTOList[i].itemTitle,
          cprice: itemInfoDTOList[i].price,
          picUrl: itemInfoDTOList[i].mainUrl,
          sale30day: itemInfoDTOList[i].saleMonthly,
          ...itemInfoDTOList[i]
        })
      }
    }
    setUpgradeInfo({
      ...res,
      goods: goodList?.length > 0 ? goodList : null
    })
  }
  // const hasDestroy = useRef(false)
  useEffect(() => {
    return () => {
      rejectCommentRef.current?.onInitiativeBehavior(false)
      rejectCommentRef.current?.onCommentVisible(false)
    }
  }, [blogComment])

  const getMoreAllAuth = () => {
    if (materialFlag) {
      return false
    }
    if (
      userAuth.isPermissions(auth, ['FS05', 'FS05_CREATOR', 'FCS06', 'FCS06_CREATOR'])
      || ((showMoveImage && userAuth.isPermissions(auth, ['FS04', 'FS04_CREATOR', 'FCS04', 'FCS04_CREATOR'])))
      || Object.keys(userInfo)?.length
      || userAuth.isPermissions(auth, ['FS14', 'FCS15'])
      || getSourceDtoData(platformId, itemData)?.originalUrl
      || userAuth.isPermissions(auth, ['FS03', 'FCS03', 'FS03_CREATOR', 'FCS03_CREATOR'])
    ) {
      return true
    }
  }

  return <div>
    {/*
      采集组件销毁会出现问题
      1.采集弹窗里面会走接口 如果在接口走完就销毁了 那么就没有办法在接口走完之后 执行setState 从而挂载弹窗
    */}
    <RejectComment
      ref={rejectCommentRef}
      chidClassName="reject-comment"
      loginUserInfo={loginUserInfo}
      messageData={{
        userId: itemData?.userId,
        inspirationId,
        blogId: imageGroupEntityId,
        collectOrSampleId: collectId,
        blogComment,
        type: 0,
      }}
    />
    <div className="mask-hover-show-wrap">
      <div className="image-card-top-mask">
        <div className="image-card-top-btn">
          {Object.keys(userInfo)?.length > 0 ? <CollectGroupBtn className="collect" currentBlog={itemData} afterJoin={props.initSubColls} /> : <div />}
          <div className="image-card-top-btn-right">
            {
              duplicateBlogNum > 1 && teamHasAuth('meinian_duplicate_images') && <div
                className="image-card-top-btn-repeated-collection"
                onClick={(e) => {
                  e.stopPropagation()
                  util.track('mn-repeat-collect-modal', {
                    module1: '单款查重',
                  })
                  renderRepeatCollectModalApiWrap({
                    data: {
                      mainUrl,
                      collectId,
                    }
                  })
                }}
              >重复
                <span style={{ color: 'var(--m-text-1)', marginLeft: '4px' }}>{formatNumber100Add(duplicateBlogNum)}</span>
              </div>
            }
            <div onClick={e => e && e.stopPropagation()}>
              {
                Object.keys(userInfo)?.length > 0 && <div
                  className="image-card-top-btn-fast-edit"
                  onClick={() => window.open(`/imageSearch?mainUrl=${itemData.mainUrl}&originUrl=${itemData.mainUrl}`)}
                >
                  <Icon type="m-zhinengsoutu" />
                </div>
              }
            </div>
            <div className="actions" onClick={e => e && e.stopPropagation()}>
              {getMoreAllAuth() ? <Dropdown
                trigger="hover"
                disabled={Object.keys(userInfo)?.length === 0
                && (platformId === PLATFORM_VALUE.UPLOAD || platformId === PLATFORM_VALUE.WEIBO)}
                // getPopupContainer={() => document.querySelector(`.mn-image-base-${collectId}`) || document.body}
                visible={dropDownVisible}
                onVisibleChange={visible => setDropDownVisible(visible)}
                overlayStyle={{ padding: '8px' }}
                overlay={<Ul style={{ width: 150 }}>
                  {userAuth.isPermissions(auth, ['FS05', 'FS05_CREATOR', 'FCS06', 'FCS06_CREATOR']) ? <>
                    <QuickEditImage
                      inspirationId={inspirationId}
                      blogId={imageGroupEntityId}
                      currentImage={{ ...itemData, ...itemData.imageEntityExtend }}
                      onChange={onChange}
                      onDeleteItem={onDeleteItem}
                    >
                      <Li
                        className="mn-dropdown-icon-li"
                        onClick={() => {
                          util.track('mn_edit_style', {
                            module1: '款式详情页',
                            module2: '款式详情',
                          })
                          setDropDownVisible(false)
                        }}
                      >
                        <Icon type="m-kuaisubianji" />快速编辑
                      </Li>
                    </QuickEditImage>
                    <Upgrade
                      currentImage={itemData}
                      inspirationId={inspirationId}
                      blogId={imageGroupEntityId}
                      loginUserInfo={loginUserInfo}
                      onDeleteItem={onDeleteItem}
                      onChange={onChange}
                      noAuth={!userAuth.isPermissions(auth, ['FS05', 'FS05_CREATOR', 'FCS06', 'FCS06_CREATOR'])}
                      innerIndex={0}
                      boxIndex={0}
                    >
                      <Li
                        className="mn-dropdown-icon-li"
                        onClick={() => {
                          util.track('mn_edit_style', {
                            module1: '款式详情页',
                            module2: '款式详情',
                          })
                          setDropDownVisible(false)
                        }}
                      >
                        <Icon type="m-bianji" />编辑
                      </Li>
                    </Upgrade>
                    <div className="li-partition" />
                  </> : null}
                  {((showMoveImage && userAuth.isPermissions(auth, ['FS04', 'FS04_CREATOR', 'FCS04', 'FCS04_CREATOR']))) ? <><Li
                    className="mn-dropdown-icon-li"
                    onClick={() => {
                      renderMoveImage({
                        blogId: imageGroupEntityId,
                        blog: itemData,
                        fromInspirationId: itemData?.inspirationId,
                        onChange: (_, isChild, hasCopy) => {
                          if (allStyleFlag) {
                            mes.pub('onMNUploadImage')
                            return
                          }
                          props?.initSubColls?.()
                          if (hasCopy) {
                            return
                          }
                          if (childrenFlag && isChild) { // 展示子灵感集并且 移动的目标是子灵感集的时候
                            props?.initWaterfall()
                            return
                          }
                          if (childrenFlag && !isChild) { // 展示子灵感集并且 移动的目标不是子灵感集的时候
                            onDeleteItem?.()
                            props?.onResize()
                            return
                          }
                          if (!childrenFlag && isChild) { // 不展示子灵感集并且 移动的目标是子灵感集的时候
                            props?.initWaterfall()
                            return
                          }
                          if (!childrenFlag && !isChild) { // 不展示子灵感集并且 移动的目标不是子灵感集的时候
                            onDeleteItem?.()
                            props?.onResize()
                            return
                          }
                          props?.initWaterfall()
                        }
                      })
                      setDropDownVisible(false)
                    }}
                  >
                    <Icon type="m-yidong" />移动
                  </Li>
                    <div className="li-partition" />
                  </>
                    : null}
                  {
                Object.keys(userInfo)?.length === 0 ? null : <DownloadImage itemData={itemData}>
                  <Li className="mn-dropdown-icon-li" onClick={() => setDropDownVisible(false)}><Icon type="m-xiazai" />下载</Li>
                </DownloadImage>
              }
                  {userAuth.isPermissions(auth, ['FS14', 'FCS15']) ? <PrintImage
                    upgradeInfo={upgradeInfo}
                    unionId={unionId}
                    blogId={imageGroupEntityId}
                    inspirationId={inspirationId}
                    platformId={platformId}
                    imageInfo={upgradeInfo?.blogGalleryImageList?.map(item => ({ ...item, mainUrl: item.childMainUrl }))}
                  >
                    <div>
                      <Li
                        className="mn-dropdown-icon-li"
                        onClick={() => {
                          request.track({ code: 6400034, type: '款式详情-打印' })
                          setDropDownVisible(false)
                        }}
                      ><Icon type="m-dayin" />打印</Li>
                    </div>
                  </PrintImage> : null}
                  {auth?.includes('FS06') || auth?.includes('FCS07') ? <ExportStyle
                    id={collectId}
                    fileName={inspirationName}
                    onChange={() => {
                      util.track('mn-statement-export', {
                        module1: '单款导出',
                        module2: '卡片导出'
                      })
                    }}
                  >
                    <Li className="mn-dropdown-icon-li" onClick={() => { setDropDownVisible(false) }}><Icon type="m-daochu" />导出</Li>
                  </ExportStyle> : null}
                  {getSourceDtoData(platformId, itemData)?.originalUrl
                    ? <Li
                        className="mn-dropdown-icon-li"
                        onClick={() => {
                          util.track('mn-origin-link', {
                            module1: '卡片',
                            module2: '站外款式原文',
                          })
                          window.open(getSourceDtoData(platformId, itemData)?.originalUrl)
                        }}
                    ><Icon type="m-tiaozhuanyuanwen" />跳转原文</Li> : null}
                  {userAuth.isPermissions(auth, ['FS03', 'FCS03', 'FS03_CREATOR', 'FCS03_CREATOR'])
                    ? <>
                      <div className="li-partition" />
                      <Remove
                        trackModule2={props.trackModule2}
                        loginUserInfo={loginUserInfo}
                        platformId={platformId}
                        imageGroupEntityId={imageGroupEntityId}
                        inspirationId={inspirationId}
                        onDeleteItem={() => {
                          onDeleteItem?.()
                          props?.onResize()
                          props?.initSubColls?.()
                        }}
                      >
                        <Li
                          className="mn-dropdown-icon-li delete"
                          onClick={() => setDropDownVisible(false)}
                        >
                          <Icon type="m-shanchu" />删除
                        </Li>
                      </Remove>
                    </> : null}
                </Ul>}
                placement="bottomRight"
                className="mn-image-card-operation"
              >
                <MoreBtn />
              </Dropdown> : null}
              {materialFlag ? <div className="icon-button text">素材</div> : null}
            </div>
          </div>
        </div>
      </div>
      <div className={classNames('bottom-mask', { bg: props.children || hiddenMark })}>
        <div className="info">
          {props.children}
          {
            hiddenMark && <CardExamine
              onDeleteItem={onDeleteItem}
              onResize={props.onResize}
              initSubColls={props.initSubColls}
              itemData={itemData}
              onChange={onChange}
              blogComment={blogComment} // 评论option
              materialFlag={materialFlag}
              hasMarkPermissions={hasMarkPermissions}
              data={data}
              outerIndex={outerIndex}
              onItemDataChange={onItemDataChange}
              loginUserInfo={loginUserInfo}
              IDEA_MASS_ROLE={IDEA_MASS_ROLE}
              MARK_STATUS={MARK_STATUS}
              onInitiativeBehavior={(val) => rejectCommentRef.current?.onInitiativeBehavior(val)}
              onCommentVisible={(val) => rejectCommentRef.current?.onCommentVisible(val)}
            />
          }
        </div>
      </div>
    </div>
  </div>
}

export const QuickEditImage = (props) => {
  const {
    blogId,
    currentImage,
    inspirationId,
    onChange,
    onDeleteItem,
    children,
  } = props

  const [visible, setVisible] = useState(false)
  return <QuickEdit
    currentImage={currentImage}
    visible={visible}
    setVisible={setVisible}
    inspirationId={inspirationId}
    blogId={blogId}
    onChange={onChange}
    onDeleteItem={onDeleteItem}
  >{children || '快速编辑'}</QuickEdit>
}

export const ExportStyle = (props) => {
  const { fileName, onChange, children, id } = props
  const [isLoading, setIsLoading] = useState(false)
  const { isAuthLimit } = useVersionNumber()
  const _onClick = async () => {
    if (isLoading) return
    if (!isAuthLimit('meinian_report_export_limit')) {
      versionNumber({
        title: '报表导出'
      })
      return
    }
    setIsLoading(true)
    const name = `${fileName}_导出时间${moment().format('YYYY-MM-DD_HH时mm分ss秒')}`
    await request.post('/zhikuan/mn/export/inspiration/export-task', {
      collectIdList: [id],
      fileName: name,
    })
    DownloadCenter.start({ type: 0 })
    onChange && onChange()
    setIsLoading(false)
  }
  return <div onClick={() => _onClick()}>
    {children || '导出'}
  </div>
}
